/* Landing kit JS: evergreen countdowns, sticky ATC, dynamic shipping dates */
(function () {
  'use strict';

  /* ---- evergreen countdown (persists per visitor+page) ---- */
  function initCountdown(el) {
    var mins = parseInt(el.getAttribute('data-countdown-mins'), 10) || 240;
    var key = 'lp_cd_' + location.pathname;
    var deadline = parseInt(localStorage.getItem(key), 10);
    var now = Date.now();
    if (!deadline || deadline < now) {
      deadline = now + mins * 60000;
      localStorage.setItem(key, deadline);
    }
    var out = el.querySelector('[data-countdown-display]') || el;
    function tick() {
      var left = deadline - Date.now();
      if (left <= 0) { // restart with a short evergreen window
        deadline = Date.now() + (20 + Math.floor(Math.random() * 20)) * 60000;
        localStorage.setItem(key, deadline);
        left = deadline - Date.now();
      }
      var h = Math.floor(left / 3600000),
          m = Math.floor((left % 3600000) / 60000),
          s = Math.floor((left % 60000) / 1000);
      out.textContent = (h < 10 ? '0' : '') + h + ':' + (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
    }
    tick();
    setInterval(tick, 1000);
  }
  document.querySelectorAll('[data-countdown-mins]').forEach(initCountdown);

  /* ---- dynamic dates for shipping timeline: data-days="2" -> "Jul 29" ---- */
  var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  document.querySelectorAll('[data-days]').forEach(function (el) {
    var range = String(el.getAttribute('data-days')).split('-');
    function fmt(offset) {
      var d = new Date(Date.now() + parseInt(offset, 10) * 86400000);
      return months[d.getMonth()] + ' ' + d.getDate();
    }
    el.textContent = range.length > 1 ? fmt(range[0]) + ' - ' + fmt(range[1]) : fmt(range[0]);
  });

  /* ---- sticky add-to-cart ---- */
  var sticky = document.querySelector('[data-lp-sticky]');
  if (sticky) {
    var form = document.querySelector('product-form form, form[action*="/cart/add"]');
    if (form) {
      var trigger = form.closest('.product__info-container') || form;
      sticky.querySelector('[data-lp-sticky-btn]').addEventListener('click', function () {
        var btn = form.querySelector('[type="submit"]');
        if (btn) btn.click(); else form.submit();
      });
      var onScroll = function () {
        var rect = trigger.getBoundingClientRect();
        sticky.classList.toggle('is-visible', rect.bottom < 0);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }
})();

/* ---- 变体选择:颜色行 × 套餐卡片 → 组合出 variant id 写回表单 ----
   单选项(data-flat)时 radio 的 value 直接就是 variant id，走旧逻辑。 */
(function () {
  var wrap = document.querySelector('[data-lp-bundle]');
  if (!wrap) return;
  var form = document.querySelector('product-form form, form[action*="/cart/add"]');
  var swatch = document.querySelector('[data-lp-swatch]');
  var flat = wrap.hasAttribute('data-flat');

  var variants = [];
  var raw = document.querySelector('[data-lp-variants]');
  if (raw) { try { variants = JSON.parse(raw.textContent); } catch (e) {} }

  function checked(name) {
    var el = document.querySelector('input[name="' + name + '"]:checked');
    return el ? el.value : null;
  }
  function pick() {
    if (flat) return null;
    var bi = parseInt(wrap.dataset.optIndex, 10);
    var bval = checked('lp-bundle-pick');
    var ci = swatch ? parseInt(swatch.dataset.optIndex, 10) : -1;
    var cval = swatch ? checked('lp-opt-1') : null;
    for (var i = 0; i < variants.length; i++) {
      var o = variants[i].o || [];
      if (o[bi] !== bval) continue;
      if (ci >= 0 && o[ci] !== cval) continue;
      return variants[i];
    }
    return null;
  }
  function apply(v, fallbackPrice) {
    var price = v ? v.p : fallbackPrice;
    if (form && (v || !flat)) {
      var idInput = form.querySelector('input[name="id"], select[name="id"]');
      var id = v ? v.id : checked('lp-bundle-pick');
      if (idInput && id) { idInput.value = id; idInput.dispatchEvent(new Event('change', { bubbles: true })); }
    }
    var sp = document.querySelector('[data-lp-sticky] .p');
    if (sp && price) sp.textContent = price;
    // 换颜色后，每张套餐卡的价格要跟着变(不同颜色理论上可以不同价)
    if (!flat && swatch) {
      var bi = parseInt(wrap.dataset.optIndex, 10);
      var ci = parseInt(swatch.dataset.optIndex, 10);
      var cval = checked('lp-opt-1');
      wrap.querySelectorAll('.lp-bundle-card').forEach(function (card) {
        var bval = card.querySelector('input').value;
        var hit = variants.filter(function (x) {
          return x.o[bi] === bval && x.o[ci] === cval;
        })[0];
        var slot = card.querySelector('[data-lp-cardprice]');
        if (hit && slot) {
          var keep = slot.querySelector('s'), em = slot.querySelector('em');
          slot.firstChild && (slot.firstChild.nodeType === 3
            ? slot.firstChild.nodeValue = hit.p + ' '
            : slot.insertBefore(document.createTextNode(hit.p + ' '), slot.firstChild));
          if (keep) slot.appendChild(keep);
          if (em) slot.appendChild(em);
        }
        card.classList.toggle('sold', hit ? !hit.a : false);
      });
    }
  }

  function onChange(e) {
    if (e.target.name !== 'lp-bundle-pick' && e.target.name !== 'lp-opt-1') return;
    wrap.querySelectorAll('.lp-bundle-card').forEach(function (c) {
      c.classList.toggle('on', c.contains(c.querySelector('input:checked')));
    });
    if (swatch) {
      swatch.querySelectorAll('.lp-swatch').forEach(function (s) {
        var si = s.querySelector('input'); s.classList.toggle('on', !!(si && si.checked));
      });
      var lbl = document.querySelector('[data-lp-optval]');
      if (lbl) lbl.textContent = checked('lp-opt-1') || '';
    }
    apply(pick(), e.target.dataset ? e.target.dataset.price : null);
  }
  wrap.addEventListener('change', onChange);
  if (swatch) swatch.addEventListener('change', onChange);
  apply(pick(), null);   // 首屏就把 id 对齐，避免默认选中和表单不一致
})();
